import { Link } from "react-router-dom";
import { Building2, Calculator, LayoutGrid, ArrowRight } from "lucide-react";
import { translations, t, type Lang } from "@/lib/translations";

interface Props { lang: Lang }

export default function HeroNextStep({ lang }: Props) {
  const T = translations;
  const chips = [
    { to: "/projects", label: t(T.bounce.chipProjects, lang), Icon: Building2 },
    { to: "/roi-calculator", label: t(T.bounce.chipRoi, lang), Icon: Calculator },
    { to: "/floor-plans", label: t(T.bounce.chipPlans, lang), Icon: LayoutGrid },
  ];

  return (
    <nav aria-label={t(T.bounce.nextStepLabel, lang)} className="mt-2">
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-3">
        {t(T.bounce.nextStepLabel, lang)}
      </p>
      <ul className="flex flex-wrap gap-2">
        {chips.map(({ to, label, Icon }) => (
          <li key={to}>
            <Link
              to={to}
              aria-label={label}
              data-cta="hero-next-step"
              className="group inline-flex items-center gap-2 rounded-full border border-primary/40 px-4 py-2 text-sm font-heading font-semibold text-foreground bg-background hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors"
            >
              <Icon className="h-4 w-4 text-primary group-hover:text-primary-foreground" />
              <span>{label}</span>
              <ArrowRight className="h-3.5 w-3.5 opacity-60 group-hover:translate-x-0.5 transition-transform" />
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
